import { DefaultContextSchema } from '../../schemas'

export const ProductTableLegacyContextSchema = DefaultContextSchema
